<template>
  <div style="text-align: left">
    <el-form ref="form" :model="notificationForm" label-width="80px" v-if="user !== 'reader'">
      <el-form-item>
        <el-row>
          <el-col :offset="22" :span="2">
            <el-button type="primary" @click="onCreateClick()"><i class="el-icon-plus"></i> 创建</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-table
      :data="notificationList"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题">
      </el-table-column>
      <el-table-column
        prop="expireAt"
        label="有效期至">
      </el-table-column>
      <el-table-column
        label="#">
        <template slot-scope="scope">
          <el-button @click="onModifyClick(scope.row)" type="primary" v-if="user !== 'reader'"><i class="el-icon-plus"></i> 编辑</el-button>
          <div v-else>#</div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="系统通知" :visible.sync="showModal">
      <el-form :model="notificationForm" :rules="rules" ref="notificationForm" label-width="100px" class="notification-form">
        <el-form-item label="通知标题" prop="title">
          <el-input v-model="notificationForm.title"></el-input>
        </el-form-item>

        <el-form-item label="通知内容" prop="content">
          <el-input  type="textarea" :rows="4" v-model="notificationForm.content"></el-input>
        </el-form-item>

        <el-form-item label="有效期至" required>
          <el-col :span="12">
            <el-form-item prop="date">
              <el-date-picker type="date"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"
                              v-model="notificationForm.expireAt"
                              style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button v-if="notificationForm.id == '0'" type="primary" @click="doCreateOrUpdate()"><i class="el-icon-plus"></i> 立即创建</el-button>
          <el-button v-else type="primary" @click="doCreateOrUpdate()"><i class="el-icon-edit"></i> 立即更新</el-button>

        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import * as api from "@/js/api.js"

export default {
  name: "NotificationList",
  data() {
    return {
      showModal: false,
      shareDetails: [],
      notificationList: [],
      dateRange: [],
      notificationForm: {
        id: '0',
        title: '',
        content: '',
        expireAt: '',
      },
      rules: {
        title: [
          { required: true, message: '请输入通知标题', trigger: 'change' },
          { min: 2, max: 50, message: '长度不小于2个字符，不超过50个字符', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入通知内容', trigger: 'change' },
          { min: 5, max: 1000, message: '长度不小于5个字符，不超过100个字符', trigger: 'change' }
        ],
        expireAt: [
          { type: 'date', required: true, message: '请选择过期时间', trigger: 'change' }
        ]
      },
      user: this.$store.state.CurrentUser,
    }
  },

  methods: {
    onModifyClick(row) {
      this.notificationForm.id = row.id
      this.notificationForm.title = row.title
      this.notificationForm.content = row.content
      this.notificationForm.expireAt = row.expireAt

      this.showModal = true
    },

    onCreateClick() {
      this.notificationForm.id = '0'
      this.notificationForm.title = ''
      this.notificationForm.content = ''
      this.notificationForm.expireAt = ''
      this.showModal = !this.showModal
    },

    doCreateOrUpdate() {
      api.publishNotification(this.notificationForm).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('操作失败')
        } else {
          this.$message.success('操作成功')
          this.showModal = false
          this.getNotificationList()
        }
      })
    },

    getNotificationList() {
      api.getAllNotifications({}).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('数据获取出错')
        } else {
          this.notificationList = result.data
        }
      })
    }
  },

  mounted() {
    this.getNotificationList()
  },
}
</script>

<style scoped>

.pagination {
  margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// src/pages/tools/notification/NotificationList.vue